export default function referenceLayers(state = [], action) {
  switch (action.type) {
    case 'UPDATE_REFERENCE_LAYERS':
      return action.referenceLayers;

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/referenceLayers.js